<template>
  <div class="app-checkout-success" v-if="this.contractId">
    <div class="top-wrapper">
    </div>
    <div class="outer-wrapper">
      <div v-if="this.isEsim && this.isMNPOrder" class="ceMnpESim">
        <dyn-slot :slot-data="{contractId: this.contractId}"><slot name="ceMnpESim"></slot></dyn-slot>
      </div>
      <div v-else-if="this.isEsim && !this.isMNPOrder" class="ceNoMnpESim">
        <dyn-slot :slot-data="{contractId: this.contractId}"><slot name="ceNoMnpESim"></slot></dyn-slot>
      </div>
      <div v-else-if="!this.isEsim && !this.isMNPOrder">
        <dyn-slot :slot-data="{contractId: this.contractId}"><slot name="ceNoMnpSim"></slot></dyn-slot>
      </div>
      <div v-else-if="!this.isEsim && this.isMNPOrder" class="ceMnpSim">
        <dyn-slot :slot-data="{contractId: this.contractId}"><slot name="ceMnpSim"></slot></dyn-slot>
      </div>
    </div>
    <slot name="moduleApps"></slot>
    <div id="customCheckoutDiv" class="last-element"></div>
    <div id="trustedShopsCheckout" style="display: none;">
      <span id="tsCheckoutOrderNr">{{this.contractId}}</span>
      <span v-if="this.customer" id="tsCheckoutBuyerEmail">{{this.customer.email}}</span>
      <span v-if="this.targetTariff" id="tsCheckoutOrderAmount">{{this.targetTariff.basicFee/100}}</span>
      <span id="tsCheckoutOrderCurrency">EUR</span>
      <span id="tsCheckoutOrderPaymentType">LASTSCHRIFT</span>
    </div>
    <div v-if="processId !== 'dummy-process-id'">
      <script type="application/javascript">
        var di = {t:'{{this.contractId}}',v:'{{fridaData.snippedId}}',l:'checkout'};
      </script>
      <script type="application/javascript" :src="'//jsctool.com/' + fridaData.snippedId + '/di.js'"></script>
      <noscript><link rel="stylesheet" type="text/css" :href="'//www.jsctool.com/di.css?t=' + this.contractId + '&v=' + fridaData.snippedId + '&l=checkout'"></noscript>
      <link rel="stylesheet" type="text/css" media="sub" :href="'//' + fridaData.fridaUrl + '/di.css?t=' + this.contractId + '&sd=1&v=' + fridaData.snippedId + '&l=checkout'">
    </div>
  </div>
</template>

<script>
import { checkoutTracking } from '@/helper/checkoutTracking'
import { mapActions } from 'vuex'

export default {
  name: 'Success',
  props: {
    process: {
      type: String,
      default: 'ordering'
    },
    stepNo: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      isMNPOrder: false,
      isEsim: false,
      contractId: '',
      processId: '',
      customer: null,
      targetTariff: null,
      fridaData: {
        snippedId: process.env.NODE_ENV !== 'production' ? 'tEhcH8' : 'GvHD2a',
        fridaUrl: process.env.NODE_ENV !== 'production' ? 'd.' + location.hostname + (location.port ? ':' + location.port : '') : 'd.simonmobile.de'
      }
    }
  },
  async mounted () {
    if (this.$store.getters['checkoutv2/' + this.process + '/confirmResult'].contractId === '') {
      window.location = '/'
    } else {
      await this.fillData()
      this.trackSuccess()
      this.resetStore()
    }
  },
  mixins: [],
  computed: {},
  methods: {
    ...mapActions('checkout', [
      'resetCompleteCheckoutStore'
    ]),
    fillData () {
      this.isMNPOrder = this.$store.getters['checkoutv2/' + this.process + '/_mnpData/active'] === true
      this.isEsim = this.$store.getters['checkoutv2/' + this.process + '/_simData/simData'].simType === 'E_SIM'
      this.contractId = this.$store.getters['checkoutv2/' + this.process + '/confirmResult'].contractId
      this.processId = this.$store.getters['checkoutv2/' + this.process + '/processId']
      this.customer = this.$store.getters['checkoutv2/' + this.process + '/_customerData/person']
      this.targetTariff = this.$store.getters['checkoutv2/' + this.process + '/_cart/targetTariff']
    },
    trackSuccess () {
      checkoutTracking(this.process, this.$store, 'success', this.stepNo)
    },
    resetStore () {
      this.$store.dispatch('checkoutv2/' + this.process + '/resetState')
      this.resetCompleteCheckoutStore()
    }
  }
}
</script>
